/**
 * Additional i18n keys for the reorganized sidebar menu (8 categories).
 * Merged into each language in languages/index.js.
 */

const menuListItemsAdditions = {
  pt: {
    translations: {
      mainDrawer: {
        listItems: {
          comunicacao: "Comunicação",
          contatosEBase: "Contatos e base",
          campanhasEQuadros: "Campanhas e quadros",
          administracao: "Administração",
          sistema: "Sistema",
          inteligencia: "Inteligência",
          feriados: "Feriados",
        },
      },
      feriados: {
        title: "Feriados",
        standardMessage: "Mensagem padrão de feriado",
        standardMessageHelp: "Esta mensagem será enviada automaticamente a cada mensagem do cliente durante um feriado ativo. Variáveis disponíveis: {{firstName}}, {{name}}, {{ms}}, {{hour}}, {{date}}.",
        standardMessagePlaceholder: "Ex: Olá! Hoje estamos em feriado nacional. Retornaremos no próximo dia útil.",
        saveMessage: "Salvar mensagem",
        messageSaved: "Mensagem de feriado salva com sucesso!",
        holidaysList: "Feriados do ano atual",
        holidaysListHelp: "Feriados nacionais são gerados automaticamente. Você pode incluir feriados municipais ou pontos facultativos da empresa. Quando um dia estiver ativo, o sistema enviará apenas a mensagem padrão, ignorando expediente e bot.",
        monthEmptyMessage: "Não há feriado nacional neste mês. Você pode adicionar feriados ou pontos facultativos abaixo.",
        dayLabel: "Dia",
        nameLabel: "Nome do feriado",
        addCustom: "Adicionar",
        customAdded: "Feriado adicionado.",
        customBadge: "Empresa",
        customPlural: "cadastrados",
      },
    },
  },
  en: {
    translations: {
      mainDrawer: {
        listItems: {
          comunicacao: "Communication",
          contatosEBase: "Contacts & base",
          campanhasEQuadros: "Campaigns & boards",
          administracao: "Administration",
          sistema: "System",
          inteligencia: "Intelligence",
          feriados: "Holidays",
        },
      },
      feriados: {
        title: "Holidays",
        standardMessage: "Standard holiday message",
        standardMessageHelp: "This message will be automatically sent for each client message during an active holiday. Variables: {{firstName}}, {{name}}, {{ms}}, {{hour}}, {{date}}.",
        standardMessagePlaceholder: "E.g.: Hello! Today is a national holiday. We will return on the next business day.",
        saveMessage: "Save message",
        messageSaved: "Holiday message saved successfully!",
        holidaysList: "Holidays for the current year",
        holidaysListHelp: "National holidays are generated automatically. You can add local holidays or company optional days. When a day is active, only the standard message is sent (no business-hours or bot flows).",
        monthEmptyMessage: "No national holiday this month. You can add local/optional holidays below.",
        dayLabel: "Day",
        nameLabel: "Holiday name",
        addCustom: "Add",
        customAdded: "Holiday added.",
        customBadge: "Company",
        customPlural: "custom",
      },
    },
  },
  es: {
    translations: {
      mainDrawer: {
        listItems: {
          comunicacao: "Comunicación",
          contatosEBase: "Contactos y base",
          campanhasEQuadros: "Campañas y cuadros",
          administracao: "Administración",
          sistema: "Sistema",
          inteligencia: "Inteligencia",
          feriados: "Feriados",
        },
      },
      feriados: {
        title: "Feriados",
        standardMessage: "Mensaje estándar de feriado",
        standardMessageHelp: "Este mensaje se enviará automáticamente por cada mensaje del cliente durante un feriado activo.",
        standardMessagePlaceholder: "Ej.: ¡Hola! Hoy es feriado nacional. Regresaremos el próximo día hábil.",
        saveMessage: "Guardar mensaje",
        messageSaved: "¡Mensaje de feriado guardado con éxito!",
        holidaysList: "Feriados del año actual",
        holidaysListHelp: "Los feriados nacionales se generan automáticamente. Puede añadir feriados locales o puntos facultativos. Cuando un día está activo, solo se envía el mensaje estándar.",
        monthEmptyMessage: "No hay feriado nacional este mes. Puede añadir feriados o puntos facultativos abajo.",
        dayLabel: "Día",
        nameLabel: "Nombre del feriado",
        addCustom: "Añadir",
        customAdded: "Feriado añadido.",
        customBadge: "Empresa",
        customPlural: "registrados",
      },
    },
  },
  tr: {
    translations: {
      mainDrawer: {
        listItems: {
          comunicacao: "İletişim",
          contatosEBase: "Kişiler ve temel",
          campanhasEQuadros: "Kampanyalar ve panolar",
          administracao: "Yönetim",
          sistema: "Sistem",
          inteligencia: "Yapay Zeka",
          feriados: "Tatiller",
        },
      },
      feriados: {
        title: "Tatiller",
        standardMessage: "Standart tatil mesajı",
        standardMessageHelp: "Bu mesaj, aktif bir tatil günü boyunca her müşteri mesajı için otomatik olarak gönderilecektir.",
        standardMessagePlaceholder: "Ör.: Merhaba! Bugün ulusal tatil. Bir sonraki iş gününde döneceğiz.",
        saveMessage: "Mesajı kaydet",
        messageSaved: "Tatil mesajı başarıyla kaydedildi!",
        holidaysList: "Yılın tatilleri",
        holidaysListHelp: "Ulusal tatiller otomatik oluşturulur. Yerel tatiller veya şirket izin günleri ekleyebilirsiniz. Gün aktifken yalnızca standart mesaj gönderilir.",
        monthEmptyMessage: "Bu ay ulusal tatil yok. Aşağıdan yerel/isteğe bağlı gün ekleyebilirsiniz.",
        dayLabel: "Gün",
        nameLabel: "Tatil adı",
        addCustom: "Ekle",
        customAdded: "Tatil eklendi.",
        customBadge: "Şirket",
        customPlural: "kayıtlı",
      },
    },
  },
};

function deepMerge(target, source) {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

export function mergeMenuKeysIntoMessages(messages) {
  const merged = { ...messages };
  for (const lang of Object.keys(menuListItemsAdditions)) {
    if (merged[lang]) {
      merged[lang] = deepMerge(merged[lang], menuListItemsAdditions[lang]);
    }
  }
  return merged;
}

export default menuListItemsAdditions;
